export default class MobileMenu {
   constructor() {
      this.menu = document.querySelector('.navbar__nav')
      this.hamburger = document.querySelector('.hamburger')
      this.init()
   }

   init() {
      if (this.menu) {
         this.toggle()
         this.hideOnClick()
      }
   }

   toggle() {
      this.hamburger.addEventListener('click', () => {
         this.hamburger.classList.toggle('is-active')
         this.menu.classList.toggle('is-active')
      })
   }

   hideOnClick() {
      const links = this.menu.querySelectorAll('li a')

      links.forEach(link => {
         link.addEventListener('click', () => {
            this.hamburger.classList.remove('is-active')
            this.menu.classList.remove('is-active')
         })
      })
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/mobile-menu.js
// module id = 11
// module chunks = 0